import React, { useState, useEffect } from 'react'
import { database, ref, get, set } from '../firebase'

const Invite = () => {
  const [invites, setInvites] = useState([
    { name: '', mobile: '', link: '' }
  ])
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')
  const [allBatches, setAllBatches] = useState([])
  const [selectedBatchIdx, setSelectedBatchIdx] = useState(0)
  const [userId, setUserId] = useState(null)

  // Get userId from localStorage (same as Task.js)
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('currentUser'))
    if (userData && (userData.mobile || userData.id)) {
      const mobile = (userData.mobile || userData.id).replace(/[^0-9]/g, '_')
      setUserId(mobile)
    } else {
      setUserId(null)
    }
  }, [])

  // Fetch all invite batches for current user
  useEffect(() => {
    const fetchBatches = async () => {
      if (!userId) {
        setAllBatches([])
        return
      }
      const inviteRef = ref(database, `/videoplayer/Users/${userId}/invite`)
      const snapshot = await get(inviteRef)
      if (snapshot.exists()) {
        const data = snapshot.val()
        // Only use invite1 as the single batch
        if (data.invite1) {
          const batchInvites = data.invite1
          const invitesArr = Object.entries(batchInvites)
            .sort((a, b) => Number(a[0]) - Number(b[0]))
            .map(([num, invite]) => ({ ...invite, key: num }))
          setAllBatches([
            {
              batchName: 'invite1',
              invites: invitesArr
            }
          ])
        } else {
          setAllBatches([])
        }
      } else {
        setAllBatches([])
      }
    }
    fetchBatches()
  }, [success, userId])

  // Add a new empty invite row
  const handleAddRow = () => {
    setInvites([...invites, { name: '', mobile: '', link: '' }])
  }

  // Handle input change for a specific row
  const handleChange = (idx, e) => {
    const newInvites = invites.map((invite, i) =>
      i === idx ? { ...invite, [e.target.name]: e.target.value } : invite
    )
    setInvites(newInvites)
  }

  // Submit all invites for current user
  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setSuccess('')
    setError('')
    try {
      if (!userId) {
        setError('User not logged in.')
        setLoading(false)
        return
      }
      // Always use invite1 as the batch node
      const batchNode = 'invite1'
      const inviteRef = ref(database, `/videoplayer/Users/${userId}/invite/${batchNode}`)
      const snapshot = await get(inviteRef)
      let startIdx = 1
      let existingInvites = {}
      if (snapshot.exists()) {
        existingInvites = snapshot.val()
        // Find the max index in existing invites
        const nums = Object.keys(existingInvites).map(Number).filter(n => !isNaN(n))
        startIdx = nums.length > 0 ? Math.max(...nums) + 1 : 1
      }
      // Store the current list under invite1/N, invite1/N+1, ...
      for (let i = 0; i < invites.length; i++) {
        const inviteDataRef = ref(database, `/videoplayer/Users/${userId}/invite/${batchNode}/${startIdx + i}`)
        await set(inviteDataRef, {
          srNo: startIdx + i,
          name: invites[i].name,
          mobile: invites[i].mobile,
          link: invites[i].link,
          createdAt: Date.now(),
        })
      }
      setSuccess('Invites submitted successfully!')
      setInvites([{ name: '', mobile: '', link: '' }])
    } catch (err) {
      setError('Failed to submit invites. Please try again.')
    }
    setLoading(false)
  }

  return (
    <>
      {/* Responsive styles */}
      <style>{`
        .invite-card, .invite-batch-card {
          max-width: 600px;
          margin: 40px auto;
          padding: 24px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 8px #eee;
        }
        .invite-batch-card {
          max-width: 700px;
          padding: 20px;
        }
        .invite-table-wrapper {
          width: 100%;
          overflow-x: auto;
          max-height: 250px; /* Show vertical scrollbar after 5 rows */
          overflow-y: auto;
        }
        .invite-table {
          width: 100%;
          border-collapse: collapse;
          min-width: 500px;
        }
        @media (max-width: 900px) {
          .invite-card, .invite-batch-card {
            max-width: 98vw;
            padding: 12px;
          }
          .invite-table {
            min-width: 400px;
          }
        }
        @media (max-width: 600px) {
          .invite-card, .invite-batch-card {
            max-width: 100vw;
            margin: 16px 0;
            padding: 8px;
            border-radius: 0;
            box-shadow: none;
          }
          .invite-table {
            min-width: 350px;
            font-size: 13px;
          }
          .invite-table th, .invite-table td {
            padding: 6px !important;
          }
          input[type="text"], input[type="tel"] {
            font-size: 13px;
            padding: 5px !important;
          }
        }
      `}</style>

      <div className="invite-card">
        <h1 style={{ textAlign: 'center', marginBottom: 24 }}>Invite User & Earn Points</h1>
        <form onSubmit={handleSubmit}>
          <div className="invite-table-wrapper">
            <table className="invite-table">
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  <th style={{ padding: 8, border: '1px solid #ddd' }}>Sr. No</th>
                  <th style={{ padding: 8, border: '1px solid #ddd' }}>Name</th>
                  <th style={{ padding: 8, border: '1px solid #ddd' }}>Mobile Number</th>
                  <th style={{ padding: 8, border: '1px solid #ddd' }}>Link</th>
                  <th style={{ padding: 8, border: '1px solid #ddd', width: 40 }}></th>
                </tr>
              </thead>
              <tbody>
                {invites.map((invite, idx) => (
                  <tr key={idx} style={{ background: idx % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                    <td style={{ padding: 8, border: '1px solid #ddd', textAlign: 'center', color: '#888' }}>{idx + 1}</td>
                    <td style={{ padding: 8, border: '1px solid #ddd' }}>
                      <input
                        type="text"
                        name="name"
                        value={invite.name}
                        onChange={(e) => handleChange(idx, e)}
                        required
                        placeholder="Enter name"
                        style={{ width: '100%', padding: 6 }}
                      />
                    </td>
                    <td style={{ padding: 8, border: '1px solid #ddd' }}>
                      <input
                        type="tel"
                        name="mobile"
                        value={invite.mobile}
                        onChange={(e) => handleChange(idx, e)}
                        required
                        pattern="[0-9]{10}"
                        placeholder="10-digit number"
                        style={{ width: '100%', padding: 6 }}
                      />
                    </td>
                    <td style={{ padding: 8, border: '1px solid #ddd' }}>
                      <input
                        type="text"
                        name="link"
                        value={invite.link}
                        onChange={(e) => handleChange(idx, e)}
                        required
                        placeholder="Enter link"
                        style={{ width: '100%', padding: 6 }}
                      />
                    </td>
                    <td style={{ padding: 8, border: '1px solid #ddd', textAlign: 'center' }}>
                      {idx === invites.length - 1 && (
                        <button
                          type="button"
                          onClick={handleAddRow}
                          style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#1976d2' }}
                          title="Add Row"
                        >
                          &#43;
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{ width: '100%', padding: 10, background: '#1976d2', color: '#fff', border: 'none', borderRadius: 4, fontWeight: 'bold', fontSize: 16, marginTop: 8 }}
          >
            {loading ? 'Submitting...' : 'Submit'}
          </button>
          {success && <div style={{ color: 'green', marginTop: 16, textAlign: 'center' }}>{success}</div>}
          {error && <div style={{ color: 'red', marginTop: 16, textAlign: 'center' }}>{error}</div>}
        </form>
      </div>

      {/* Submitted Invites Section - Separate from Form */}
      {allBatches.length > 0 && (
        <div style={{ maxWidth: 700, margin: '40px auto 0 auto' }}>
          <h3 style={{ textAlign: 'center', marginBottom: 24, color: '#1976d2', letterSpacing: 1 }}>Submitted Invite Lists</h3>

          {/* Show Latest Invite List Button */}
          {/* Removed: There is only one invite list now */}

          {/* Navigation for Invite Lists */}
          {/* Only show the selected batch table, but now only one batch exists */}
          <div className="invite-batch-card">
            <h4 style={{ textAlign: 'left', marginBottom: 16, color: '#333', borderLeft: '4px solid #1976d2', paddingLeft: 12 }}>
              Invite List
            </h4>
            <div className="invite-table-wrapper">
              <table className="invite-table">
                <thead>
                  <tr style={{ background: '#e3eafc' }}>
                    <th style={{ padding: 10, border: '1px solid #ddd' }}>Sr. No</th>
                    <th style={{ padding: 10, border: '1px solid #ddd' }}>Name</th>
                    <th style={{ padding: 10, border: '1px solid #ddd' }}>Mobile Number</th>
                    <th style={{ padding: 10, border: '1px solid #ddd' }}>Link</th>
                  </tr>
                </thead>
                <tbody>
                  {allBatches[0].invites.map((invite, inviteIdx) => (
                    <tr key={invite.key} style={{ background: inviteIdx % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                      <td style={{ padding: 10, border: '1px solid #ddd', textAlign: 'center', color: '#888' }}>{inviteIdx + 1}</td>
                      <td style={{ padding: 10, border: '1px solid #ddd' }}>{invite.name}</td>
                      <td style={{ padding: 10, border: '1px solid #ddd' }}>{invite.mobile}</td>
                      <td style={{ padding: 10, border: '1px solid #ddd' }}>{invite.link}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Invite
